import React, { useState, useContext, useEffect } from 'react';
import { AuthContext } from '../context/AuthContext';
import AdminDashboard from '../components/AdminDashboard';
import ChangePasswordForm from '../components/ChangePasswordForm';
import ScheduleManager from '../components/ScheduleManager';
import QuizManager from '../components/QuizManager';
import BlogManagePage from './BlogManagePage';
import AdminFeedbackManager from '../components/AdminFeedbackManager';
import AdminFeeManager from '../components/AdminFeeManager';
import UserManagement from '../components/UserManagement';
import api from '../api';

const AdminPage = () => {
    const { user } = useContext(AuthContext);
    const [activeTab, setActiveTab] = useState('users');
    const [users, setUsers] = useState([]);

    useEffect(() => {
        if (activeTab === 'stats') {
            fetchUsers();
        }
    }, [activeTab]);

    const fetchUsers = async () => {
        try {
            const res = await api.get('/users/students');
            setUsers(res.data);
        } catch (error) {
            console.error('Error fetching users:', error);
        }
    };

    const tabs = [
        { id: 'users', name: 'Quản lý người dùng', icon: 'fas fa-users' },
        { id: 'classes', name: 'Quản lý lớp học', icon: 'fas fa-chalkboard-teacher' },
        { id: 'schedules', name: 'Quản lý lịch học', icon: 'fas fa-calendar-alt' },
        { id: 'quizzes', name: 'Quản lý bài tập', icon: 'fas fa-tasks' },
        { id: 'blogs', name: 'Quản lý blog lý thuyết', icon: 'fas fa-blog' },
        { id: 'fees', name: 'Quản lý học phí', icon: 'fas fa-wallet' },
        { id: 'feedback', name: 'Tin nhắn hỗ trợ', icon: 'fas fa-question-circle' },
        { id: 'profile', name: 'Thông tin cá nhân', icon: 'fas fa-user-cog' },
        { id: 'stats', name: 'Thống kê', icon: 'fas fa-chart-bar' }
    ];

    if (user?.role !== 'admin') {
        return (
            <div className="flex min-h-[60vh] flex-col items-center justify-center gap-4 rounded-3xl bg-white/70 p-12 text-center shadow-xl backdrop-blur">
                <h2 className="text-2xl font-semibold text-slate-900">Không có quyền truy cập</h2>
                <p className="text-slate-600">Bạn cần quyền quản trị viên để truy cập trang này.</p>
            </div>
        );
    }

    return (
        <div className="space-y-6">
            <div className="rounded-3xl bg-white/70 p-8 shadow-xl backdrop-blur">
                <h1 className="text-3xl font-bold text-slate-900 mb-2">Bảng điều khiển quản trị</h1>
                <p className="text-slate-600">Chào mừng {user.name}, quản lý hệ thống học tập của bạn</p>
            </div>

            <div className="flex flex-wrap gap-2 rounded-3xl bg-white/70 p-4 shadow-xl backdrop-blur">
                {tabs.map((tab) => (
                    <button
                        key={tab.id}
                        onClick={() => setActiveTab(tab.id)}
                        className={`inline-flex items-center gap-2 rounded-2xl px-6 py-3 text-sm font-semibold transition ${
                            activeTab === tab.id
                                ? 'bg-indigo-600 text-white shadow-lg'
                                : 'bg-white/50 text-slate-700 hover:bg-white/80'
                        }`}
                    >
                        <i className={tab.icon} aria-hidden></i>
                        {tab.name}
                    </button>
                ))}
            </div>

            <div className="rounded-3xl bg-white/70 p-8 shadow-xl backdrop-blur">
                {activeTab === 'users' && <UserManagement />}

                {activeTab === 'classes' && <AdminDashboard />}

                {activeTab === 'schedules' && <ScheduleManager />}
                {activeTab === 'quizzes' && <QuizManager />}
                {activeTab === 'blogs' && <BlogManagePage />}
                {activeTab === 'fees' && <AdminFeeManager />}

                {activeTab === 'feedback' && <AdminFeedbackManager />}

                {activeTab === 'profile' && (
                    <div className="space-y-6">
                        <h2 className="text-2xl font-semibold text-slate-900">Thông tin cá nhân</h2>

                        <div className="rounded-2xl bg-white p-6 border border-slate-200">
                            <div className="flex items-center gap-4 mb-6">
                                <div className="flex h-16 w-16 items-center justify-center rounded-full bg-indigo-100 text-indigo-600">
                                    <i className="fas fa-user text-2xl" aria-hidden></i>
                                </div>
                                <div>
                                    <h3 className="text-xl font-semibold text-slate-900">{user.name}</h3>
                                    <p className="text-slate-600">{user.email}</p>
                                    <span className="inline-flex rounded-full bg-red-100 px-3 py-1 text-xs font-semibold text-red-800 mt-2">
                                        Quản trị viên
                                    </span>
                                </div>
                            </div>
                        </div>

                        <ChangePasswordForm
                            onSuccess={(message) => {
                                alert(message);
                            }}
                        />
                    </div>
                )}

                {activeTab === 'stats' && (
                    <div className="space-y-6">
                        <h2 className="text-2xl font-semibold text-slate-900">Thống kê hệ thống</h2>
                        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
                            <div className="rounded-2xl bg-gradient-to-br from-blue-500 to-blue-600 p-6 text-white">
                                <div className="flex items-center gap-4">
                                    <div className="flex h-12 w-12 items-center justify-center rounded-full bg-white/20">
                                        <i className="fas fa-users text-xl" aria-hidden></i>
                                    </div>
                                    <div>
                                        <p className="text-sm opacity-80">Tổng người dùng</p>
                                        <p className="text-2xl font-bold">{users.length}</p>
                                    </div>
                                </div>
                            </div>
                            <div className="rounded-2xl bg-gradient-to-br from-green-500 to-green-600 p-6 text-white">
                                <div className="flex items-center gap-4">
                                    <div className="flex h-12 w-12 items-center justify-center rounded-full bg-white/20">
                                        <i className="fas fa-chalkboard-teacher text-xl" aria-hidden></i>
                                    </div>
                                    <div>
                                        <p className="text-sm opacity-80">Lớp học đang hoạt động</p>
                                        <p className="text-2xl font-bold">-</p>
                                    </div>
                                </div>
                            </div>
                            <div className="rounded-2xl bg-gradient-to-br from-purple-500 to-purple-600 p-6 text-white">
                                <div className="flex items-center gap-4">
                                    <div className="flex h-12 w-12 items-center justify-center rounded-full bg-white/20">
                                        <i className="fas fa-chart-line text-xl" aria-hidden></i>
                                    </div>
                                    <div>
                                        <p className="text-sm opacity-80">Hoạt động trong tuần</p>
                                        <p className="text-2xl font-bold">-</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                )}
            </div>
        </div>
    );
};

export default AdminPage;